import { __makeTemplateObject } from "tslib";
import { css } from '@skbkontur/react-ui/lib/theming/Emotion';
export var jsStyles = {
    warning: function (t) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), t.warningText);
    },
    error: function (t) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), t.errorText);
    },
};
var templateObject_1, templateObject_2;
